import React from "react";
import { Box, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import { Form } from "react-bootstrap";
import type { LifecycleRetreat } from "../../../../../types/retreatLifecycle";
import { DASHBOARD_NAVY } from "../dashboardUi";
import { RegistrationOpenRowIcons } from "../RegistrationOpenRowIcons";
import { retreatActionButtonSx } from "../RetreatDashboardActionIcons";

export function RegistrationOpenActions({
  row,
  isSuperAdmin,
  canEdit,
  onHistory,
  onDelete,
  onStatusToggle,
  onEditInactiveReason,
  onWaitlistExport,
  onFreezeToggle,
}: {
  row: LifecycleRetreat;
  isSuperAdmin: boolean;
  canEdit: boolean;
  onHistory: (r: LifecycleRetreat) => void;
  onDelete: (r: LifecycleRetreat) => void;
  onStatusToggle: (r: LifecycleRetreat) => void;
  onEditInactiveReason: (r: LifecycleRetreat) => void;
  onWaitlistExport: (r: LifecycleRetreat) => void;
  onFreezeToggle: (r: LifecycleRetreat) => void;
}) {
  const frozen = row.freeze === "FREEZE";
  const name = row.parishName || row.title || "retreat";

  if (isSuperAdmin) {
    return (
      <Stack spacing={1} sx={{ width: "100%", minWidth: 0 }}>
        <Stack direction="row" spacing={0.75} flexWrap="wrap" useFlexGap alignItems="center">
          <RegistrationOpenRowIcons
            row={row}
            frozen={frozen}
            showDelete
            onHistory={onHistory}
            onDelete={onDelete}
          />
          {row.waitList === true && (
            <span
              className="waitlistcouple"
              style={{ cursor: "pointer" }}
              onClick={() => onWaitlistExport(row)}
            >
              WL
            </span>
          )}
        </Stack>
        <Stack
          direction="row"
          spacing={1.5}
          flexWrap="wrap"
          useFlexGap
          alignItems="center"
          sx={{ width: "100%" }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
            <Typography variant="caption" color="text.secondary" fontWeight={700}>
              Active
            </Typography>
            <Form.Check
              className={`switchSize ${
                row.status === "ACTIVE" ? "toggle-on-status" : "toggle-off-status"
              }`}
              type="checkbox"
              name="status"
              value={row.status}
              checked={row.status === "ACTIVE"}
              onChange={() => onStatusToggle(row)}
              id={`card-status-${row.id}`}
            />
            {row.status === "INACTIVE" && (
              <Tooltip title="Edit Deactivate Reason" placement="bottom" arrow>
                <IconButton
                  size="small"
                  aria-label={`Edit deactivate reason for ${name}`}
                  onClick={() => onEditInactiveReason(row)}
                  sx={{ ...retreatActionButtonSx, color: DASHBOARD_NAVY }}
                >
                  <i className="mdi mdi-pencil text-lg font-size" style={{ fontSize: 17 }} />
                </IconButton>
              </Tooltip>
            )}
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
            <Typography variant="caption" color="text.secondary" fontWeight={700}>
              Freeze
            </Typography>
            <Form.Check
              className={`switchSize ${
                row.freeze === "FREEZE" ? "toggle-on" : "toggle-off"
              }`}
              type="switch"
              name="freeze"
              value={row.freeze}
              checked={row.freeze === "FREEZE"}
              onChange={() => onFreezeToggle(row)}
              id={`card-freeze-${row.id}`}
            />
          </Box>
        </Stack>
      </Stack>
    );
  }

  if (!canEdit) return null;

  return (
    <RegistrationOpenRowIcons
      row={row}
      frozen={frozen}
      showDelete={false}
      onHistory={onHistory}
      onDelete={onDelete}
    />
  );
}
